'use client';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { ChevronDown } from 'react-feather';
import { newFilters } from '@/utils/newFilters';
import classes from './FilterComps.module.css';

const NewCategoriesFilter = (props) => {
	const {
		theCategory,
		theOption,
		theSubType,
		clearHandler,
		uniqueCategories,
		uniqueSubCategories,
		uniqueTypes,
	} = props;

	const router = useRouter();
	const pathname = usePathname();

	const categoryParam =
		pathname.split('/').at(1) === 'collections'
			? pathname.split('/').at(2)
			: null;
	const optionParam =
		pathname.split('/').at(1) === 'collections'
			? pathname.split('/').at(3)
			: null;
	const typeParam =
		pathname.split('/').at(1) === 'collections'
			? pathname.split('/').at(4)
			: null;

	const [showCategory, setShowCategory] = useState(true);
	const [showOptions, setShowOptions] = useState(false);

	const [displayCategories, setDisplayCategories] = useState([]);
	const [displaySubCategories, setDisplaySubCategories] = useState([]);

	const showCategoryHandler = () => {
		setShowCategory(!showCategory);
	};

	const urlHandler = (category, option, type) => {
		let newParams = new URLSearchParams(window.location.search);
		newParams.delete('keyword');
		newParams.delete('category');
		newParams.delete('option');
		newParams.delete('subType');

		if (
			!categoryParam &&
			category &&
			!option &&
			!type &&
			location.pathname !== '/collections'
		) {
			newParams.set('category', category);
			router.push(pathname + '?' + newParams.toString());
		} else if (
			(categoryParam && category && !option && !type) ||
			(location.pathname === '/collections' && category && !option && !type)
		) {
			router.push(`/collections/${category}` + '?' + newParams.toString());
			return;
		}
		if (
			!optionParam &&
			category &&
			option &&
			!type &&
			!location.pathname.includes('/collections')
		) {
			newParams.set('category', category);
			newParams.set('option', option);
			router.push(pathname + '?' + newParams.toString());
		} else if (
			(optionParam && option && !type) ||
			(location.pathname.includes('/collections') && option && !type)
		) {
			router.push(
				`/collections/${category}/${option}` + '?' + newParams.toString()
			);

			return;
		}

		if (
			!typeParam &&
			category &&
			option &&
			type &&
			!location.pathname.includes('/collections')
		) {
			newParams.set('category', category);
			newParams.set('option', option);
			newParams.set('subType', type);
			router.push(pathname + '?' + newParams.toString());
		} else if (
			(typeParam && type) ||
			(location.pathname.includes('/collections') && type)
		) {
			router.push(
				`/collections/${category}/${option}/${type}` +
					'?' +
					newParams.toString()
			);

			return;
		}

		if (!categoryParam && !optionParam && !typeParam) {
			router.push(pathname + '?' + newParams.toString());
		}
	};

	const clearHandlerHandler = (e, category, subCategory, type) => {
		let newParams = new URLSearchParams(window.location.search);

		if (!categoryParam && category) {
			if (theOption) {
				clearHandler(e, 'setOption', 'option');
			} else {
				clearHandler(e, 'setCategory', 'category');
			}
		} else if (categoryParam && category) {
			if (theOption) {
				router.push(`/collections/${category}`);
			} else router.push(`/collections` + '?' + newParams.toString());
		}
		if (!optionParam && subCategory) {
			clearHandler(e, 'setOption', 'option');
		} else if (optionParam && subCategory) {
			router.push(`/collections/${category}` + '?' + newParams.toString());
		}
		if (!typeParam && type) {
			clearHandler(e, 'setSubType', 'subType');
		} else if (typeParam && type) {
			router.push(
				`/collections/${category}/${subCategory}` + '?' + newParams.toString()
			);
		}
	};

	useEffect(() => {
		if (categoryParam || theCategory) {
			setDisplayCategories(
				newFilters.categories.filter((cate) => cate.id === theCategory)
			);
			setShowOptions(true);
		} else {
			setDisplayCategories(newFilters.categories);
		}
	}, [theCategory]);

	useEffect(() => {
		if (
			(optionParam || theOption) &&
			theCategory &&
			displayCategories.length > 0
		) {
			const hasTypes = displayCategories[0]?.subCategories.find(
				(subCate) => subCate.id === theOption
			)?.types.length;
			if (hasTypes) {
				setDisplaySubCategories(
					displayCategories[0]?.subCategories.filter(
						(subCate) => subCate.id === theOption
					)
				);
			} else {
				setDisplaySubCategories(displayCategories[0]?.subCategories);
			}
		} else {
			setDisplaySubCategories(displayCategories[0]?.subCategories);
		}
	}, [displayCategories, theOption]);

	// Pre-calculate counts for categories, subcategories, and types
	const categoryCounts = {};
	uniqueCategories &&
		uniqueCategories.length > 0 &&
		uniqueCategories?.forEach((item) => {
			categoryCounts[item.name] = item.count;
		});

	const subCategoryCounts = {};
	uniqueSubCategories &&
		uniqueSubCategories.length > 0 &&
		uniqueSubCategories?.forEach((item) => {
			subCategoryCounts[item.name] = item.count;
		});

	const typeCounts = {};
	uniqueTypes &&
		uniqueTypes.length > 0 &&
		uniqueTypes?.forEach((item) => {
			typeCounts[item.name] = item.count;
		});

	return (
		<>
			<div className={classes.desktop}>
				<div className={classes.dropDown}>
					<div
						onClick={() => showCategoryHandler()}
						className={classes.justifyBetween}
					>
						Category{' '}
						<ChevronDown
							size={13}
							className={showCategory ? classes.flip : classes.icon}
						/>
					</div>
					{showCategory && (
						<div className={classes.box}>
							{displayCategories
								.sort(
									(a, b) =>
										(categoryCounts[b.category] || 0) -
										(categoryCounts[a.category] || 0)
								)
								.map((category, idx) => {
									const isActive = theCategory === category.id;
									const categoryCount = categoryCounts[category.category];
									return (
										<div key={category.id}>
											<div
												value={category.id}
												className={
													isActive ? classes.active : classes.selection
												}
												onClick={
													isActive
														? (e) => clearHandlerHandler(e, category.id)
														: () => urlHandler(category.id)
												}
											>
												<h3 className={classes.underline}>
													{category.category}{' '}
													{category.category === 'Seating' ||
													category.category === 'Storage'
														? ' Furniture'
														: ''}
												</h3>
												<span className={classes.count}>
													{categoryCount &&
														`(${categoryCount.toLocaleString(undefined, {
															maximumFractionDigits: 2,
														})})`}
												</span>
											</div>
											{isActive &&
												showOptions &&
												displaySubCategories?.length && (
													<>
														{displaySubCategories
															.sort(
																(a, b) =>
																	(subCategoryCounts[b.name] || 0) -
																	(subCategoryCounts[a.name] || 0)
															)
															.map((subCate, id) => {
																const isActiveSubCate =
																	theOption === subCate.id;
																const subCategoryCount =
																	subCategoryCounts[subCate.name];
																return (
																	<div key={subCate.id}>
																		<div
																			value={subCate.id}
																			className={
																				isActiveSubCate
																					? classes.activeOptions
																					: classes.selectionOptions
																			}
																			onClick={
																				isActiveSubCate
																					? (e) =>
																							clearHandlerHandler(
																								e,
																								category.id,
																								subCate.id
																							)
																					: () =>
																							urlHandler(
																								category.id,
																								subCate.id
																							)
																			}
																		>
																			<h3 className={classes.underline}>
																				{subCate.name}
																			</h3>
																			<span className={classes.count}>
																				{subCategoryCount &&
																					`(${subCategoryCount.toLocaleString(
																						undefined,
																						{ maximumFractionDigits: 2 }
																					)})`}
																			</span>
																		</div>

																		{isActiveSubCate && (
																			<>
																				{subCate.types
																					.sort(
																						(a, b) =>
																							(typeCounts[b.name] || 0) -
																							(typeCounts[a.name] || 0)
																					)
																					.map((type, id) => {
																						const isActiveType =
																							theSubType === type.id;
																						const typeCount =
																							typeCounts[type.name];
																						return (
																							<div
																								key={type.id}
																								value={type.id}
																								className={
																									isActiveType
																										? classes.activeType
																										: classes.selectionType
																								}
																								onClick={
																									isActiveType
																										? (e) =>
																												clearHandlerHandler(
																													e,
																													category.id,
																													subCate.id,
																													type.id
																												)
																										: () =>
																												urlHandler(
																													category.id,
																													subCate.id,
																													type.id
																												)
																								}
																							>
																								<h3
																									className={classes.underline}
																								>
																									{type.name}
																								</h3>
																								<span className={classes.count}>
																									{typeCount &&
																										`(${typeCount.toLocaleString(
																											undefined,
																											{
																												maximumFractionDigits: 2,
																											}
																										)})`}
																								</span>
																							</div>
																						);
																					})}
																			</>
																		)}
																	</div>
																);
															})}
													</>
												)}
										</div>
									);
								})}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default NewCategoriesFilter;
